import type { ClefQuestion } from '@/data/clefQuiz';

/**
 * Perguntas de apoio para a aula "Sustenido, bemol e bequadro".
 * Cada pergunta mostra um acidente no lugar da pauta e pede o seu efeito.
 */
export const ACCIDENTAL_QUESTIONS: ClefQuestion[] = [
  {
    id: 'acc-sharp',
    glyph: '♯',
    glyphHint: 'Acidente',
    question: 'O que o sustenido (♯) faz com a nota?',
    options: [
      'Sobe a nota meio tom',
      'Desce a nota meio tom',
      'Devolve a nota ao som natural',
      'Aumenta a duração da nota',
    ],
    answerIndex: 0,
    explanation:
      'O sustenido eleva a nota meio tom — no teclado, isso corresponde à tecla preta logo à direita da nota natural.',
  },
  {
    id: 'acc-flat',
    glyph: '♭',
    glyphHint: 'Acidente',
    question: 'O que o bemol (♭) faz com a nota?',
    options: [
      'Desce a nota meio tom',
      'Sobe a nota meio tom',
      'Deixa a nota mais forte',
      'Repete a nota',
    ],
    answerIndex: 0,
    explanation:
      'O bemol abaixa a nota meio tom — no teclado, é a tecla preta logo à esquerda da nota natural.',
  },
  {
    id: 'acc-natural',
    glyph: '♮',
    glyphHint: 'Acidente',
    question: 'Para que serve o bequadro (♮)?',
    options: [
      'Devolver a nota ao seu som natural',
      'Subir a nota meio tom',
      'Descer a nota meio tom',
      'Indicar uma pausa',
    ],
    answerIndex: 0,
    explanation:
      'O bequadro cancela um sustenido ou bemol anterior e devolve a nota à sua altura natural.',
  },
  {
    id: 'acc-position',
    glyph: '♯  ♭  ♮',
    glyphHint: 'Posição na pauta',
    question: 'Onde o acidente é escrito na partitura?',
    options: [
      'À esquerda da cabeça da nota',
      'À direita da cabeça da nota',
      'Sempre acima da pauta',
      'Somente no fim do compasso',
    ],
    answerIndex: 0,
    explanation:
      'O acidente vem imediatamente à esquerda da nota que ele altera, valendo para todas as notas iguais no mesmo compasso.',
  },
];